import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import {
  StyledText,
  MainHolder,
  Children,
  Body,
  DynamicButton,
} from "../../../components/common/basic";
import { AlertModal, BackButton } from "../../../components/common";
import useDigitalSkillsTraining from "./hooks/useDigitalSkillsTraining";
import { Stepper } from "./components/Stepper";
import { SummaryPage } from "./components/SummaryPage";
import { ContactDetailsPage } from "./components/ContactDetailsPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTheme } from "../../../hooks";
import LocationSelector from "./components/LocationSelector";

const DigitalSkillsTrainingRegistrationForm = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "YPYCRegistrationForm",
        firebase_screen_class: "YPYCRegistrationForm",
      })
    );
  }, []);
  const [ActivePage, setActivePage] = useState();
  const [page, setPage] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const steps = ["Region", "Location", "Contact", "Complete"];
  const {
    background,
    history,
    attendanceOptions,
    handleChange,
    state,
    registrationStatus,
    isLoading,
    validateForm,
    submitForm,
    countries,
    token,
    hasRegistered,

    regionSelected,
    setRegionSelected,
    selectedLocation,
    setSelectedLocation,
    modeOfAttendance,
    setModeOfAttendanceLocal,
  } = useDigitalSkillsTraining();

  const switchPage = (page) => {
    setPage(page);
  };

  const nextPage = () => {
    const next = page + 1;

    if (next === steps.length) {
      submitForm(state);
    }

    if (next < steps.length) {
      if (page > 1 && !validateForm()) return;
      switchPage(next);
    }
  };

  useEffect(() => {
    const compData = {
      state,
      handleChange,
      background,
      attendanceOptions,
      countries,
      modeOfAttendance,
      gotoEditPage: () => setPage(0),
    };

    switch (page) {
      case 0:
        // Step 1: Region Selection
        setActivePage(
          <RegionSelector
            setRegion={setRegionSelected}
            regionSelected={regionSelected}
          />
        );
        break;

      case 1:
        setActivePage(
          <LocationSelector
            setLocation={setSelectedLocation}
            selectedLocation={selectedLocation}
            regionSelected={regionSelected}
            setModeOfAttendance={setModeOfAttendanceLocal}
            modeOfAttendance={modeOfAttendance}
          />
        );

        break;

      case 2:
        // Step 3: Contact Details Page
        setActivePage(<ContactDetailsPage {...compData} />);
        break;

      case 3:
        // Step 4: Summary Page
        setActivePage(<SummaryPage {...compData} />);
        break;

      default:
        // Default case (Contact Details Page)
        setActivePage(<ContactDetailsPage {...compData} />);
        break;
    }
  }, [
    page,
    state,
    regionSelected,
    selectedLocation,
    modeOfAttendance,
    setModeOfAttendanceLocal,
  ]);

  useEffect(() => {
    const requiredFields = [
      "fullname",
      "phone",
      "emailAddress",
      "whatsappNumber",
      "educationLevel",
      "ownBusiness",
      // "onlineDetails",
      "eventSource",
    ];
    const isEmpty = requiredFields.some(
      (field) => !state[field] || state[field].trim() === ""
    );

    const isInperson = modeOfAttendance === "In-Person";

    setDisableSubmit(
      !regionSelected ||
        (page > 0 && !modeOfAttendance) ||
        (isInperson && !selectedLocation) ||
        (isEmpty && page > 1)
    );
  }, [regionSelected, validateForm, state, page]);

  useEffect(() => {
    if (registrationStatus?.success === true) {
      setShowAlert(true);
    }
    if (registrationStatus?.success === false) {
      setShowAlert(true);
    }
  }, [registrationStatus?.success]);

  return (
    <MainHolder>
      <BackButton
        onClick={() => {
          if (page < 1) {
            history.goBack();
          } else {
            switchPage(page - 1);
          }
        }}
      />
      <Children>
        <Header>
          <div style={{ textAlign: "center" }}>
            <StyledText
              size={24}
              style={{ fontFamily: "MTNMedium" }}
              margin="0"
            >
              {" "}
            </StyledText>
          </div>
        </Header>
        <Body>
          {hasRegistered ? <HasAlreadyRegisteredModal token={token} /> : null}
          {
            // TODO: Update success property
            showAlert && (
              <AlertModal
                background={background}
                success={registrationStatus?.success}
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                <div>
                  <StyledText size={24}>
                    Registration{" "}
                    {registrationStatus?.success ? "successful" : "failed"}
                  </StyledText>
                  <div
                    style={{
                      width: "70%",
                      minWidth: "300px",
                      margin: "0 auto 30px auto",
                    }}
                  >
                    <StyledText
                      size={12}
                      style={{
                        fontFamily: "MTNRegular",
                      }}
                    >
                      {registrationStatus?.success
                        ? `Complete any course on MTN Skills Academy to stand a chance to win a prize.`
                        : registrationStatus?.message ||
                          "Sorry, an unexpected error occurred!"}
                    </StyledText>
                  </div>
                  <DynamicButton
                    onClick={() => {
                      registrationStatus?.success
                        ? goToSkillsAcademy()
                        : history.push(`/home?token=${token}`);
                    }}
                    label={
                      registrationStatus?.success
                        ? "Go to Skills Academy"
                        : "Ok"
                    }
                    disabled={isLoading}
                    color={background}
                    fullWidth
                  />
                  <DynamicButton
                    onClick={() => {
                      history.push(`/home?token=${token}`);
                    }}
                    variant="outlined"
                    disabled={false}
                    label={"Home"}
                    color={background}
                    fullWidth
                  />
                </div>
              </AlertModal>
            )
          }

          <div style={{ boxSizing: "border-box", padding: "0 15px 50px 15px" }}>
            <div style={{ padding: "20px 0 20px 0" }}>
              <Stepper
                currentPage={page}
                background={background}
                navigateFunc={switchPage}
                steps={steps}
              />
            </div>
            {ActivePage}
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                background: "#fff",
                borderTop: "1px solid #ddd",
              }}
            >
              <div style={{ padding: "10px 30px" }}>
                <DynamicButton
                  onClick={nextPage}
                  label={determineButtonText(registrationStatus?.loading, page)}
                  disabled={disableSubmit || registrationStatus?.loading}
                  color={background}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </Body>
      </Children>
    </MainHolder>
  );
};

function determineButtonText(isLoading, pageNumber) {
  if (isLoading) return "Processing...";

  if (pageNumber === 2) return "Register";

  if (pageNumber === 3) return "Complete";

  return "Continue";
}

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default DigitalSkillsTrainingRegistrationForm;

function HasAlreadyRegisteredModal({ token }) {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const history = useHistory();

  return (
    <AlertModal background={background} success={false}>
      <div>
        <StyledText size={24}>You have already registered</StyledText>
        <div
          style={{
            width: "70%",
            minWidth: "300px",
            margin: "0 auto 30px auto",
          }}
        >
          <StyledText
            size={12}
            style={{
              fontFamily: "MTNRegular",
            }}
          >
            Visit the MTN Skills Academy Portal and complete a course of your
            interest before the 28th of March to secure your spot
          </StyledText>
        </div>
        <DynamicButton
          onClick={() => {
            goToSkillsAcademy();
          }}
          disabled={false}
          label={"Go to Skills Academy"}
          color={background}
          fullWidth
        />
        <DynamicButton
          onClick={() => {
            history.push(`/home?token=${token}`);
          }}
          variant="outlined"
          disabled={false}
          label={"Home"}
          color={background}
          fullWidth
        />
      </div>
    </AlertModal>
  );
}

const RegionSelector = ({ setRegion, regionSelected }) => {
  const regions = [
    { label: "Greater Accra Region", value: "Greater Accra" },
    { label: "Ashanti Region", value: "Ashanti" },
    { label: "Western Region", value: "Western" },
    { label: "Central Region", value: "Central" },
    { label: "Eastern Region", value: "Eastern" },
    { label: "Bono Region", value: "Bono" },
    { label: "Volta Region", value: "Volta" },
    { label: "Northern Region", value: "Northern" },
    { label: "Upper East Region", value: "Upper East" },
    { label: "Upper West Region", value: "Upper West" },
    { label: "Bono East Region", value: "Bono East" },
    { label: "Western North Region", value: "Western North" },
    { label: "Oti Region", value: "Oti" },
    { label: "Ahafo Region", value: "Ahafo" },
  ];

  return (
    <div>
      <StyledText>Select your region</StyledText>
      <Select
        onChange={({ target }) => {
          const { value } = target;
          setRegion(value);
        }}
        value={regionSelected || ""}
        placeholder="Please select a region"
      >
        <option value="" disabled>
          Select your region
        </option>{" "}
        {/* Empty option */}
        {regions.map((item) => {
          const { label, value } = item;
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </Select>
    </div>
  );
};

function goToSkillsAcademy() {
  analytics().then((anl) =>
    logEvent(anl, "clicked_on_skills_academy", {
      firebase_screen: "digital_skills_training_registration_form_already",
      firebase_class: "digital_skills_training_registration_form_already",
    })
  );
  window.open("https://skillsacademy.mtn.com/", "_blank");
}

const Select = styled.select`
  border-radius: 5px;
  margin-bottom: 20px;
  font-family: "MTNRegular";
  padding: 10px;
  width: 100%;
  height: 45px;
  background-color: white;
`;
